












import { Component, Vue } from 'vue-property-decorator';
import { INarrative } from '../models';
import { render } from 'slimdown-js';

@Component({
  components: {},
})
export default class ScenarioTextVert extends Vue {
  private narrative: INarrative = {} as INarrative;
  constructor() {
    super();
  }

  private async init() {
    this.$store.states.map(s => {
      this.narrative = s.app.narrative;
    });
  }

  private getMarkdown(text: string): string {
    return render(text);
  }

  async mounted(): Promise<void> {
    console.log(`ScenarioText mounted`);
    await this.init();
  }
}
